import React from 'react'
import clsx from 'clsx'
import { Button } from '@material-ui/core'
import useStyles from './FormFieldsStyle'

export default function Form({ field, errors }) {
  const classes = useStyles()

  return (
    <div
      className={clsx(
        classes.flexColumnCenter,
        field.withMargin && classes.withMargin
      )}
    >
      {field.selectedFile && (
        <img src={field.selectedFile} width="180px" alt="img"></img>
      )}
      <input
        type="file"
        ref={field.inputRef}
        style={{ display: 'none' }}
        onChange={(event) => {
          errors[field.key] = null
          field.onChange(event)
        }}
      />
      <Button
        variant="outlined"
        color="primary"
        fullWidth
        className={clsx(classes.topMargin, classes.secondaryButton)}
        onClick={() => field.inputRef.current.click()}
      >
        {field.label}
      </Button>
      {errors[field.key] && (
        <span className={classes.formError}>{errors[field.key]}</span>
      )}
    </div>
  )
}
